// extracted by mini-css-extract-plugin
export default {"header":"Header_header__VZKdH","headerImg":"Header_headerImg__Rs71F","linkphone":"Header_linkphone__CyrsW","imgLogo":"Header_imgLogo__fGlv0"};